// @flow
import { UneTypesActionTypes } from './constants';

type UneTypesAction = { type: string, payload: {} | string };

// common success
export const uneTypesApiResponseSuccess = (actionType: string, data: any): UneTypesAction => ({
    type: UneTypesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const uneTypesApiResponseError = (actionType: string, error: string): UneTypesAction => ({
    type: UneTypesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listUneTypes = (): UneTypesAction => ({
    type: UneTypesActionTypes.LIST_UNE_TYPES,
    payload: {},
});

export const listUneTouristTypes = (): UneTypesAction => ({
    type: UneTypesActionTypes.LIST_UNE_TOURIST_TYPES,
    payload: {},
});

export const listCuisineTypes = (): UneTypesAction => ({
    type: UneTypesActionTypes.LIST_CUISINE_TYPES,
    payload: {},
});

export const listClientTypes = (): UneTypesAction => ({
    type: UneTypesActionTypes.LIST_CLIENT_TYPES,
    payload: {},
});

export const resetUneTypes = (): UneTypesAction => ({
    type: UneTypesActionTypes.RESET,
    payload: {},
});